import { Tree } from "antd";
import React, { Component } from "react";
import { Context } from "../../Context";

class RbacFolder extends Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = {
      selectedFolder: "",
      treeData: [],
      defaultSelectedKeys: [],
    };
  }


  componentDidMount = () => {
    this.setTreeData();
  };

  setTreeData = () => {
    let treeData = [];
    let folder_structure = this.context.contextState.folder_structure;
    let folders_accessible = this.context.contextState.folders_accessible;

    if (folder_structure.children && folder_structure.children.length > 0) {
      folder_structure.disabled = !folders_accessible.includes("root");
      if (!folders_accessible.includes("root")) {
        delete folder_structure['title']; 
      }
      this.updateChildren(folder_structure.children, folders_accessible);
    }

    treeData.push(folder_structure);

    this.setState({ treeData });
  };

  updateChildren = (children, folders_accessible) => {
    for (let child of children) {
      child.disabled = !folders_accessible.includes(child.key);
      if (!folders_accessible.includes(child.key)) {
        delete child['title']; 
      }
      if (child.children && child.children.length > 0) {
        this.updateChildren(child.children, folders_accessible);
      }
    }
  };

  onSelect = (selectedKeys, info) => {
    if (selectedKeys.length > 0) {
      window.localStorage.setItem("default_folder", selectedKeys[0]); 
      this.context.setDefaultFolder(selectedKeys[0]); 
    }
    this.props.selectedFolder(selectedKeys);
  };

  // onCheck = (checkedKeys, info) => {
  //   console.log("onCheck", checkedKeys, info);
  // };

  render() {
    return (
      <div>
        {this.state.treeData.length > 0 ? (
          <Tree
            defaultExpandAll={true}
            defaultSelectedKeys={[this.context.contextState.default_folder]}
            onSelect={this.onSelect}
            treeData={this.state.treeData}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default RbacFolder;
